import React, { useState } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useFormik } from "formik";
import TextInput from "../../common/textfield/TextInput";
import SelectFiled from "../../common/textfield/SelectFiled";
import { useNavigate } from "react-router-dom";
import { Button } from "../../common/Button";
import { failed, success } from "../../common/Toastify";
import { FormikObj, typeOptions } from "./Constants";
import { useOrgQuery } from "../../../hooks/ReactQueryHooks/useOrgQuery";
import TextArea from "../../common/textfield/TextArea";
import { Tooltip } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import Select from 'react-select';
import { createGroup } from "../../api/Group";
import { getPatientList, getPractitionerList } from "../../api/Individual";
import moment from "moment";
function AddGroup() {
    const navigate = useNavigate();
    const [btnLoading, setBtnLoading] = useState(false)
    const [organizations, setOrganizations] = useState([]);
    const [usersList, setUsersList] = useState([]);

    const formik = useFormik({
        ...FormikObj,
        onSubmit: (values) => { 
            setBtnLoading(true) 
            createGroup({
                ...values,
                member: values?.member.map(item => ({
                    entity: {
                        display: item?.name,
                        reference: `${item?.type}/${item?.id}`,
                        type: item?.type
                    },
                    period: {
                        start: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
                        end: null
                    },
                    inactive: false
                })),
                quantity: values?.member.length,
            }).then((res) => {
                navigate("/app/manage-groups");
                success(res.message);
            }).catch(res => failed(res?.response?.data?.message || res?.response?.data?.error || res.message))
                .finally(() => setBtnLoading(false));
        },
    });

    
    const handleOrganizationSelect = (event) => {
        const orgId = event?.target?.value;
        formik.setFieldValue("orgId", orgId);
        formik.setFieldValue("type", "");
        
    };
    const handleTypeSelect = async (event) => {
        const type = event?.target?.value;
        formik.setFieldValue("type", type);
    
        const orgId = formik.values.orgId;
        if (!orgId) return console.warn("Organization ID not selected.");
    
        try {
            let res;

            if (type === "Patient") {
                res = await getPatientList(orgId);
            } else if (type === "Practitioner") {
                res = await getPractitionerList(orgId);
            } 
            const capitalizeFirstLetter = (str) => {
                return str
                    ?.split(' ')  
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) 
                    .join(' '); 
            }; 
            const userlist = res?.result?.map((user) => ({
                name: capitalizeFirstLetter(user?.name?.[0]?.text),
                value: user?.id,
                type: user?.resourceType,
                label: capitalizeFirstLetter(user?.name?.[0]?.text) || "Unnamed",
                id: user?.id,
            })) || [];
    
            setUsersList(userlist);
        } catch (err) {
            console.error("Error fetching list:", err);
        }
    };
    

    const onSuccessOrg = (data) => {
        setOrganizations(data?.map((org) => org = { ...org, "value": org.id }))
    };

    useOrgQuery({ onSuccess: onSuccessOrg });

    return (
        <section className="common-listing">
            <div className="heading-wrap mb-3">
                <Tooltip title="Go back">
                    <div style={{ marginRight: "1rem", cursor: "pointer" }} onClick={() => navigate(-1)}>
                        <ArrowBack />
                    </div>
                </Tooltip>
            </div>
            <div className="custom-card p-4">
                <form className="common-form border-fields" onSubmit={formik.handleSubmit}>
                    <Row>
                        <Col>
                            <TextInput keyField={"name"} label={"Name"} formik={formik} placeholder={"Name"} />
                        </Col>
                        <Col>
                            <SelectFiled 
                                keyField={"orgId"} 
                                label={"Select Organization"} 
                                formik={formik} 
                                options={organizations} 
                                onChange={handleOrganizationSelect}
                                value={formik.values.orgId}
                            />
                        </Col>
                        <Col>
                            <SelectFiled
                                keyField={"type"}
                                label={"Select Type"}
                                formik={formik}
                                options={ typeOptions } 
                                onChange={handleTypeSelect}
                            />
                        </Col>
                    </Row> 
                    <Row>
                        
                        <Col>
                            <div className="field-wrap">
                                <label>Select Members</label>
                                <Select
                                    onChange={(data) => formik.setFieldValue("member", data)}
                                    isMulti
                                    name="member"
                                    options={usersList}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                />
                                <div>{formik?.touched["member"] && formik?.errors["member"] ? <div className="error-text">{formik?.errors["member"]}</div> : null}</div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <TextArea required={false} keyField={"description"} label={"Description"} formik={formik} placeholder={"Description..."} />
                        </Col>
                        <Col></Col>
                    </Row>
                    <div className="btn-wrap" style={{ display: 'flex' }}>
                        <Button onClick={() => navigate("/app/manage-groups")} variant="secondary" title="Cancel">Cancel</Button>
                        <Button type="submit" isLoading={btnLoading}>Create</Button>
                    </div>
                </form>
            </div>
        </section>
    );
}

export default AddGroup;